import * as _ from 'lodash';
import { getLogger } from '../../diagnostics/logger';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { ENSURE_COMMAND_STOCKS, INITIAL_AUTHENTICATION, LOAD_COMMAND_STOCKS } from '../../actions/actionTypes';
import {
  loadCommandStocks,
  loadCommandStocksFailure,
  loadCommandStocksPending,
  loadCommandStocksSuccess,
} from '../../actions/commandStocksActions';
import { Action } from '../../actions/commonActions';
import { ensureProvisioningExcludedDays } from '../../actions/simProvision/provisioningExcludedDays';
import * as commandTypeApi from '../../api/commandTypeApi';
import { HashMap } from '../../constants';
import { LoadCommandStocksPayload } from '../../models/payload/loadRequests';
import { SimCommandCreate } from '../../models/simCommand';
import { SubmissionState } from '../../models/state/simProvision/simProvisionState';
import { selectSubmission } from '../../selectors/submissions';

const log = getLogger('simmanagement.sagas.login');

/**
 * Ensure that the command stocks have been loaded.
 * @param action The action that invoked the saga.
 */
export function* ensureCommandTabsSaga(action: Action<LoadCommandStocksPayload>) {
  const payload = action.payload;
  if (typeof payload === 'undefined') {
    log.error('ensureAvailableCommandsSaga payload is undefined');
    return;
  }

  const submission: SubmissionState = yield select(selectSubmission);
  const { expiresOn, params } = submission;
  if (
    payload.commandType !== params.commandType ||
    payload.selectedStockSerialNumbers.join(',') !== params.selectedStockSerialNumbers.join(',') ||
    (expiresOn && expiresOn < new Date())
  ) {
    yield put(loadCommandStocks(payload));
  }
}

/**
 * Load the command tabs
 * @param action The action that invoked the saga.
 */
export function* loadCommandTabsSaga(action: Action<LoadCommandStocksPayload>) {
  if (typeof action.payload !== 'undefined') {
    const { payload } = action;
    yield put(loadCommandStocksPending(payload));
    try {
      const response: HashMap<SimCommandCreate> = yield call(commandTypeApi.getCommands, payload);
      yield put(loadCommandStocksSuccess(response, payload));

      const definitionIds = _.keys(response).map((id) => parseInt(id, 10));
      yield put(ensureProvisioningExcludedDays(definitionIds));
    } catch (error: any) {
      yield put(loadCommandStocksFailure(error, payload));
    }
  }
}

/*
 * Initialize all sagas related to command tabs
 */
export function* initComandTabsSagas() {
  yield take(INITIAL_AUTHENTICATION);
  yield takeEvery(ENSURE_COMMAND_STOCKS, ensureCommandTabsSaga);
  yield takeEvery(LOAD_COMMAND_STOCKS, loadCommandTabsSaga);
}
